// THIS FILE IS AUTO GENERATED
import { GenIcon } from '../lib';
export function MdPause(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
      }
    }]
  })(props);
}
;